import tw from "twin.macro";
import styled from "styled-components";
import ReactModalAdapter from "helpers/ReactModalAdapter.js";

export const Container = tw.div`min-h-screen bg-primary-900 text-white font-medium flex justify-center -m-8`;
export const Content = tw.div`max-w-screen-xl m-0 sm:mx-20 sm:my-16 bg-white text-gray-900 shadow sm:rounded-lg flex justify-center flex-1`;
export const MainContainer = tw.div`lg:w-1/2 xl:w-5/12 p-6 sm:p-12`;
export const LogoLink = tw.a``;
export const LogoImage = tw.img`h-12 mx-auto`;
export const MainContent = tw.div`mt-12 flex flex-col items-center`;
export const Heading = tw.h1`text-2xl xl:text-3xl font-extrabold`;
export const FormContainer = tw.div`w-full flex-1 mt-8`;
export const Form = tw.form`mx-auto max-w-xs`;
export const Input = tw.input`w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5 first:mt-0`;

export const SubmitButton = styled.button`
  ${tw`mt-5 tracking-wide font-semibold bg-primary-500 text-gray-100 w-full py-4 rounded-lg hover:bg-primary-900 transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed`}
  .icon {
    ${tw`w-6 h-6 -ml-2`}
  }
  .text {
    ${tw`ml-3`}
  }
`;

export const ValidationText = styled.span`
  ${tw`text-sm block mt-1`}
  color: ${props => props.valid ? 'green' : 'red'};
`;

export const MessageText = styled.span`
  ${tw`block mt-3 text-center text-sm`}
  color: ${props => props.success ? 'green' : 'red'};
`;

export const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    ${tw`fixed inset-0 z-50 bg-black bg-opacity-75`}
  }
  &__content {
    ${tw`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-8 max-w-md w-full shadow-2xl`}
  }
`;

export const ModalHeading = tw.h2`text-2xl font-bold mb-4 text-gray-900`;
export const ModalText = tw.p`mb-4 text-gray-700`;
export const ModalHighlight = tw.p`font-semibold text-lg mb-6 text-primary-500`;

export const ModalButton = styled.button`
  ${tw`mt-3 tracking-wide font-semibold text-gray-100 w-full py-3 rounded-lg transition-all duration-300 ease-in-out focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed`}
  ${props => props.primary ? tw`bg-primary-500 hover:bg-primary-900` : tw`bg-gray-500 hover:bg-gray-700`}
`;

// Loading Spinner Component
export const Spinner = styled.div`
  ${tw`inline-block w-4 h-4 border-2 border-solid border-r-transparent rounded-full animate-spin`}
`;

export const LoadingWrapper = tw.div`flex items-center justify-center gap-2`;
